// extracted by extract-css-chunks-webpack-plugin
module.exports = {"homeAdvantages":"homeAdvantages_vqL3M mb-10 w-full sm_text-center"};